import React from 'react';
import { Link } from 'react-router-dom';
import '../../components/mobile.css';

const zodiacSigns = [
    { name: 'Aries', date: 'Mar 21 - Apr 19', icon: 'assets/images/svg/horoscope/h1.svg' },
    { name: 'Taurus', date: 'Apr 20 - May 20', icon: 'assets/images/svg/horoscope/h2.svg' },
    { name: 'Gemini', date: 'May 21 - Jun 20', icon: 'assets/images/svg/horoscope/h3.svg' },
    { name: 'Cancer', date: 'Jun 21 - Jul 22', icon: 'assets/images/svg/horoscope/h4.svg' },
    { name: 'Leo', date: 'Jul 23 - Aug 22', icon: 'assets/images/svg/horoscope/h5.svg' },
    { name: 'Virgo', date: 'Aug 23 - Sep 22', icon: 'assets/images/svg/horoscope/h6.svg' },
    { name: 'Libra', date: 'Sep 23 - Oct 22', icon: 'assets/images/svg/horoscope/h7.svg' },
    { name: 'Scorpio', date: 'Oct 23 - Nov 21', icon: 'assets/images/svg/horoscope/h8.svg' },
    { name: 'Sagittarius', date: 'Nov 22 - Dec 21', icon: 'assets/images/svg/horoscope/h9.svg' },
    { name: 'Capricorn', date: 'Dec 22 - Jan 19', icon: 'assets/images/svg/horoscope/h10.svg' },
    { name: 'Aquarius', date: 'Jan 20 - Feb 18', icon: 'assets/images/svg/horoscope/h11.svg' },
    { name: 'Pisces', date: 'Feb 19 - Mar 20', icon: 'assets/images/svg/horoscope/h12.svg' }
];

const HoroscopeList = () => {
    // Group signs into rows of 3 for mobile view
    const rows = [];
    for (let i = 0; i < zodiacSigns.length; i += 3) {
        rows.push(zodiacSigns.slice(i, i + 3));
    }

    return (
        <section className="as_horoscope_wrapper  as_padderBottom80">
            <div className="container">
                <div className="row mb-4">
                    <div className="col-12 text-center">
                        <h1 className="as_heading as_heading_center">Daily Horoscope</h1>
                        <p className="section-subtitle">Choose your sign to reveal today’s horoscope.</p>
                    </div>
                </div>
                <div className="horoscope-grid">
                    {zodiacSigns.map((sign, index) => (
                        <Link 
                            key={index}
                            to={`/horoscope/${sign.name.toLowerCase()}`}
                            className="horoscope-card text-decoration-none"
                        >
                            <div className="as_horoscope_box text-center">
                                <img 
                                    src={sign.icon} 
                                    alt={sign.name} 
                                    className="mb-2"
                                    style={{ width: '40px', height: '40px' }}
                                />
                                <h4 className="mb-1">{sign.name}</h4>
                                <p className="text-muted small">{sign.date}</p>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HoroscopeList;
